/**
 * AB Test Selectors
 * NgRx selectors for querying AB test state
 * 
 * Note: Variant assignment selectors return empty/null - assignments are handled
 * client-side via VariantAssignmentService with localStorage.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ABTestState } from './ab-test.reducer';

export const selectABTestState = createFeatureSelector<ABTestState>('abTest');

// Active test definitions
export const selectActiveTests = createSelector(selectABTestState, (state) => state.activeTests);

export const selectActiveTestById = (testId: string) =>
  createSelector(selectActiveTests, (tests) => tests.find((test) => test.id === testId));

// Loading & error states
export const selectABTestLoading = createSelector(selectABTestState, (state) => state.loading);

export const selectABTestError = createSelector(selectABTestState, (state) => state.error);

// Variant assignment selectors (client-side only, synced with localStorage)
export const selectVariantAssignments = createSelector(selectABTestState, (state) => state.assignments);

export const selectVariantForTest = (testId: string) =>
  createSelector(selectVariantAssignments, (assignments) => {
    return assignments[testId]?.variantId;
  });

export const selectAssignmentForTest = (testId: string) =>
  createSelector(selectVariantAssignments, (assignments) => assignments[testId]);

export const selectAllAssignments = createSelector(selectVariantAssignments, (assignments) =>
  Object.values(assignments)
);

export const selectAssignmentsByUserId = (userId: string) =>
  createSelector(selectAllAssignments, (assignments) =>
    assignments.filter((assignment) => assignment.userId === userId)
  );
